var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-table',{staticClass:"m-t-20",attrs:{"firstIndex":false,"rowKey":"id","tableData":_vm.table.list,"loading":_vm.table.loading,"columns":_vm.getButtonTrue? _vm.table.tableCol : _vm.table.tableCol1},on:{"handleDelete":_vm.handleDelete}})
}
var staticRenderFns = []

export { render, staticRenderFns }